import FJCommunityList from './FJCommunityList';
import useLocalStore from '../../../../hooks/useLocalStore';
import PropTypes from 'prop-types';
import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity';
const FJCommunityListContainer = props => {
    useLocalStore();
    const { active } = props;
    const dispatch = useDispatch();
    const communityList = useSelector(state => state.community.communityList);
    const communityPageInfo = useSelector(state => state.community.communityPageInfo);
    const curCategory = useSelector(state => state.community.curCommunityCategory);
    useEffect(() => {
        dispatch(FJActionCommunity.initCommunityListAction());
    }, [dispatch]);

    const getMoreCommunityListAction = useCallback(() => {
        dispatch(FJActionCommunity.getMoreCommunityListAction());
    }, [dispatch]);

    return (
        <FJCommunityList
            active={active}
            communityList={communityList}
            getMoreData={getMoreCommunityListAction}
            communityPageInfo={communityPageInfo}
            curCategory={curCategory}
        />
    );
};

FJCommunityListContainer.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default FJCommunityListContainer;
